"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useBaseProductFilter;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _usePreferredLocale = _interopRequireDefault(require("@sprinx/react-globalize/usePreferredLocale"));

var _useShoppingCurrency = _interopRequireDefault(require("../../shop/useShoppingCurrency"));

var _useShoppingRegion = _interopRequireDefault(require("../../shop/useShoppingRegion"));

var _buildBaseProductFilter = _interopRequireDefault(require("./buildBaseProductFilter"));

//
function useBaseProductFilter() {
  var ignorePrice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var region = (0, _useShoppingRegion.default)();
  var locale = (0, _usePreferredLocale.default)();
  var currency = (0, _useShoppingCurrency.default)();
  return _react.default.useCallback(function () {
    var taxonomies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return (0, _buildBaseProductFilter.default)({
      ignorePrice: ignorePrice,
      locale: locale,
      currency: currency,
      taxonomies: ["/eshop-".concat(region)].concat((0, _toConsumableArray2.default)(taxonomies))
    });
  }, [currency, ignorePrice, locale, region]);
}